import React from "react";
import SectionHeader from "../components/SectionHeader";

const FounderIntroSection = ({ data }) => (

    <section className="founder-journey">

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}
     

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                highlight={data.highlight}
                description={data.description}
            />


            {/* =================================================
                 FOUNDER INTRO
            ================================================== */}

            {data.founder && (
                <div className="founder-intro">

                    <div className="founder-intro-photo">

                        {data.founder.image && (
                            <img
                                src={data.founder.image}
                                alt={
                                    data.founder.alt ||
                                    data.founder.name
                                }
                            />
                        )}

                    </div>

                    <div className="founder-intro-content">

                        {data.founder.label && (
                            <span className="story-label">
                                {data.founder.label}
                            </span>
                        )}

                        <h3>
                            {data.founder.title}
                        </h3>

                        {(data.founder.paragraphs || []).map(
                            (paragraph, i) => (
                                <p key={i}>
                                    {paragraph}
                                </p>
                            )
                        )}

                    </div>

                </div>
            )}
        </div>

    </section>
);

export default FounderIntroSection;